import type { ChildNode } from '@gitbook/slate';

import type { BlockDiffChangeType } from '../types';

/*
 * To avoid nodes with duplicated keys in documents that represent diffs,
 * we generate new keys for certain changes (like deletions).
 * An example scenario is a node moved from one location to another, that will be marked as deleted in the original location,
 * and added in the new location.
 *
 * But we need to keep track of the original keys to be able to match them with the original nodes.
 */

/**
 * Get a diff key for a node.
 */
export function getDiffKey(nodeKey: string, change: BlockDiffChangeType): string {
    return `diff:${change}-${nodeKey}`;
}

/**
 * Get the original key from a diff key.
 */
export function getOriginalDiffKey(diffKey: string): string {
    return diffKey.replace(/^diff:\S+-/, '');
}

/**
 * Transform the key of a node to a diff key.
 */
export function transformDiffKey<T extends ChildNode>(node: T, change: BlockDiffChangeType): T {
    const originalKey = node.key;
    const newKey = getDiffKey(originalKey, change);
    // @ts-ignore - slate typing
    return node.merge({ key: newKey });
}
